import React, { useState } from 'react';
import Linkpages from "./Linkpages";
import '../css/vagadent.css';
import '../css/about.css';
import '../css/media.css';
import { useTranslation } from "react-i18next";
import atamImg from '../images/atam.png';
import V11 from '../images/V11.jpg';


function About(props) {
    const { t, i18n } = useTranslation("common");
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <div className="about-page-wrapper">
            {/* ==========================================
               1. HEADER SECTION
               ========================================== */}
            <div className="header-container">
                <div className="logo-group">
                    <div className="logo"></div>
                    <div className="brand-text">
                        <div className="vagadent">{t('welcome.title')}</div>
                        <div className="dental">{t('welcome.title1')}</div>
                    </div>
                </div>

                <div className={`nav-menu ${menuOpen ? 'open' : ''}`}>
                    <Linkpages />
                </div>

                <div className="header-right">
                    <div className="leng">
                        <button onClick={() => i18n.changeLanguage('hay')}>ՀԱՅ</button>
                        <button onClick={() => i18n.changeLanguage('ru')}>РУ</button>
                        <button onClick={() => i18n.changeLanguage('en')}>ENG</button>
                    </div>
                    <div className={`menu-dots ${menuOpen ? 'active' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>

            {/* ==========================================
               2. MAIN CONTENT SECTION
               ========================================== */}
            <section className="about-section">
                <div className="about-container">

                    {/* Ձախ կողմ՝ Տեքստեր և Առավելություններ */}
                    <div className="about-content">
                        <div className="about-title-wrapper">
                            <h2 className="about-title">{t('about.title')}</h2>
                            <div className="about-tooth-box">
                                <img src={atamImg} alt="Tooth Icon" className="about-tooth-icon" />
                            </div>
                        </div>
                        <div className="about-underline"></div>

                        {/* Տեքստային խումբ */}
                        <div className="about-text-group">
                            <p className="about-text">{t('about.description1')}</p>
                            <p className="about-text">{t('about.description2')}</p>
                        </div>

                        {/* ✔ Առավելությունների բլոկ */}
                        <div className="about-features">
                            <div className="feature-item">
                                <span className="feature-icon">✔</span>
                                <div className="feature-info">
                                    <h4>{t('about.feat1_title')}</h4>
                                    <p>{t('about.feat1_desc')}</p>
                                </div>
                            </div>

                            <div className="feature-item">
                                <span className="feature-icon">✔</span>
                                <div className="feature-info">
                                    <h4>{t('about.feat2_title')}</h4>
                                    <p>{t('about.feat2_desc')}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Աջ կողմ՝ Նկար և Փորձի տարիների Badge */}
                    <div className="about-image-box">
                        <div className="about-image" style={{ backgroundImage:`url(${V11})`}}></div>
                        <div className="about-image-badge">
                            <h3>16+</h3>
                            <p>{t('about.years_exp')}</p>
                        </div>
                    </div>

                </div>
            </section>
        </div>
    );
}

export default About;